


















































































































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
//@ts-ignore
import store from "../../store";
// @ts-ignore
import Tools from "../../helpers/Tools";
import VideoEmbed from "../VideoEmbed.vue";
import {ContentPack, CurrentGame, SelectPackMessage, Player} from "../../../types";
import EventApi from "../../api/EventsApi";
import MessageHelper from "../../helpers/MessageHelper";

@Component({
    components: {VideoEmbed},
    props: {
        game: {
            type: Object,
            required: true
        },
        preset: {
            type: Object,
            required: true
        }
    }
})

export default class SuggestedGame extends Vue {
    private isVisibleDropdown: boolean = false;
    private rulesAreVisible: boolean = false;
    private packModel: string = '';
    private game!: CurrentGame;
    private preset!: ContentPack;

    mounted(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'openSuggest'});
    }

    /**
     * ID игрока
     */
    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * ID автора
     */
    private get authorId(): string
    {
        return store.getters.getGameState.tasks.main.author;
    }

    /**
     * Является автором
     */
    private get isAuthor(): boolean
    {
        return this.playerId === this.authorId;
    }

    private get author(): Player
    {
        return store.getters.getGameState.playersData[this.authorId];
    }

    /**
     * Игроки
     */
    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    /**
     * Игроки
     */
    private get playerData(): Player|null
    {
        const filtered = this.players.filter(player => {
           return player.id === this.playerId;
        });

        if (typeof filtered[0] !== 'undefined') {
            return filtered[0];
        }

        return null;
    }

    private get isGuest(): boolean
    {
        if (!this.playerData) {
            return true;
        }
        return this.playerData.connectionStatus === 'guest';
    }

    /**
     * Закрыть модалку
     * @private
     */
    private closeModal(): void
    {
        this.$emit('close-modal');
    }

    /**
     * Тоггл списка паков
     * @private
     */
    private toggleDropdown(): void
    {
        this.isVisibleDropdown = !this.isVisibleDropdown;
    }

    /**
     * Закрытие списка паков
     * @private
     */
    private closeDropdown(): void
    {
        this.isVisibleDropdown = false;
    }

    /**
     * Получить ID видео
     * @param url
     * @private
     */
    private getYoutubeVideoId(url: string): string
    {
        return Tools.getYouTubeVideoId(url);
    }

    /**
     * Показать правила
     * @private
     */
    private showRules(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.rulesAreVisible = true;
    }

    /**
     * Скрыть правила
     * @private
     */
    private closeRules(): void
    {
        this.rulesAreVisible = false;
    }

    /**
     * Изменить пак
     */
    private changePack(pack: ContentPack): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.closeDropdown();

        MessageHelper.sendMessage('suggestTask', {
            packId: pack.id,
            activityId: this.game.id,
        });
    }

    private start(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});

        const data = {
            contentPackId: this.preset.id,
            setId: 1,
            activityId: this.game.id,
            newGame: true,
        };

        MessageHelper.sendMessage('getContentPackTasks', data);
        this.$analyticsApi.goal('start_game');
    }

    private goToCatalog(): void
    {
        this.closeModal();
        EventApi.triggerEvent(EventApi.OPEN_CATALOG);
    }
}
